import React from 'react';
import { ProjectModel } from '../../../models/ProjectModel';
import { AiAnalysisLabels } from './AiAnalysisLabels';
import { projectApi } from '../../../APIs/projectApi';
import { useGet } from '../../../hooks/useApi';
import { Points } from './MapProjects';
import { AiAnalysisType } from '../../../models/AiAnalysisType';

type Prop = {
    projects: ProjectModel[];
    onLabelTypeChange: (
        aiAnalysisTypeId: string,
        type: number,
        checked: boolean
    ) => void;
};
export const AiTypes: React.FC<Prop> = (props) => {
    const { projects, onLabelTypeChange } = props;

    const { data: aiAnalysisTypes } = useGet(projectApi.get.aiAnalysisTypes);

    if (!aiAnalysisTypes) {
        return <></>;
    }

    // プロジェクトがあるものだけ表示
    const aiFilter = (type: AiAnalysisType) => {
        return projects.find((project) => {
            return type.aiAnalysisTypeId === project.aiAnalysisTypeId;
        })
            ? true
            : false;
    };

    return (
        <div className="ai-selector">
            {aiAnalysisTypes.data
                .filter((type) => {
                    return aiFilter(type);
                })
                .map((aiAnalysisType) => {
                    return (
                        <div key={aiAnalysisType.aiAnalysisTypeId}>
                            <div className="ai-selector-label">
                                {aiAnalysisType.nameJa}
                            </div>
                            <div className="checkbox-container">
                                <AiAnalysisLabels
                                    onLabelTypeChange={onLabelTypeChange}
                                    aiAnalysisType={aiAnalysisType}
                                ></AiAnalysisLabels>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};
